import { MultiplicationTableConfig } from '../../../types/dynamicComponents';

export const MULTIPLICATION_TABLE_COMPONENT_TYPE = 'multiplication_table';

export const DEFAULT_MULTIPLICATION_TABLE_CONFIG: MultiplicationTableConfig = {
  minNumber: 1,
  maxNumber: 25,
  defaultNumber: 2,
  multiplierMin: 1,
  multiplierMax: 26,
};

export const getDefaultMultiplicationConfigJson = (): string =>
  JSON.stringify(DEFAULT_MULTIPLICATION_TABLE_CONFIG, null, 2);

export const parseMultiplicationTableConfig = (configJson?: string | null): MultiplicationTableConfig => {
  if (!configJson) {
    return DEFAULT_MULTIPLICATION_TABLE_CONFIG;
  }

  try {
    const parsed = JSON.parse(configJson) as Partial<MultiplicationTableConfig>;
    const minNumber = Number.isFinite(parsed.minNumber)
      ? Math.max(1, Math.floor(parsed.minNumber!))
      : DEFAULT_MULTIPLICATION_TABLE_CONFIG.minNumber;

    const maxNumber = Number.isFinite(parsed.maxNumber)
      ? Math.max(minNumber, Math.floor(parsed.maxNumber!))
      : DEFAULT_MULTIPLICATION_TABLE_CONFIG.maxNumber;

    const multiplierMin = Number.isFinite(parsed.multiplierMin)
      ? Math.max(1, Math.floor(parsed.multiplierMin!))
      : DEFAULT_MULTIPLICATION_TABLE_CONFIG.multiplierMin;

    const configuredMultiplierMax = Number.isFinite(parsed.multiplierMax)
      ? Math.max(multiplierMin, Math.floor(parsed.multiplierMax!))
      : DEFAULT_MULTIPLICATION_TABLE_CONFIG.multiplierMax;

    const multiplierMax = Math.max(configuredMultiplierMax, 26);

    const defaultNumber = Number.isFinite(parsed.defaultNumber)
      ? Math.min(maxNumber, Math.max(minNumber, Math.floor(parsed.defaultNumber!)))
      : DEFAULT_MULTIPLICATION_TABLE_CONFIG.defaultNumber;

    return {
      minNumber,
      maxNumber,
      defaultNumber,
      multiplierMin,
      multiplierMax,
    };
  } catch {
    return DEFAULT_MULTIPLICATION_TABLE_CONFIG;
  }
};
